import styled from 'styled-components';

export const MarginWrapper = styled.div`
  margin: ${(p) => (p.lesser ? '1.5rem' : '2rem')} 0;

  @media screen and (max-width: 768px) {
    margin: ${(p) => (p.lesser ? '0.5rem' : '1rem')} 0;
  }
`;

export default MarginWrapper;
